import React, { Component } from "react";
import { Helmet } from "react-helmet";

//Miscellaneous
import { isDesktop } from "react-device-detect";

// Components
import PageHeader from "../../components/PageHeader/PageHeader";
import PageContent from "../../components/PageContent/PageContent";
import PageFooter from "../../components/PageFooter/PageFooter";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import CountrySetting from "../Setting/CountrySetting";


class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.updatePredicate();
    window.addEventListener("resize", this.updatePredicate);
  }

  componentWillMount() {
    window.removeEventListener("resize", this.updatePredicate);
  }

  updatePredicate() {
    document.documentElement.style.setProperty("--app-height", `${window.innerHeight}px`);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location &&
      this.props.location !== undefined &&
      this.props.location.pathname !== undefined &&
      this.props.location.pathname !== prevProps.location.pathname
    ) {
      window.scrollTo(0, 0);     
    }
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const loginRegisterPath = window.location.pathname === "/login";
    const forgetPasswordPath = window.location.pathname === "/forget-password";
    const verifyPasswordToken = window.location.pathname === "/verify-forgot-password/:token";
    const changePasswordPath = window.location.pathname === "/change-password";
    const changePasswordToken = window.location.pathname === "/change-password/:token" ;
    return (
      <Auxiliary>
        {isDesktop ? (
          <Helmet>
            <html className="desktop-view" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          </Helmet>
        ) : (
          <Helmet>
            <html className="mobile-view" />
            <meta name="viewport" content="user-scalable=no,viewport-fit=cover" />
          </Helmet>
        )}

        {<CountrySetting />}

        {/* {loginRegisterPath || forgetPasswordPath || verifyPasswordToken || changePasswordPath || changePasswordToken ? ( */}
        { forgetPasswordPath || verifyPasswordToken || changePasswordPath || changePasswordToken ? (
          <div className="master-container">
            <div className="master-content">
              <PageContent />
            </div>
          </div>
        ) : (
          <div className="master-container">
            {isDesktop ? (
              <>
                <PageHeader />
                <div className="master-content">
                  <PageContent />
                </div>
                <PageFooter />
              </>
            ) : (
              <div className="master-content">
                <PageContent />
              </div>
            )}
          </div>
        )}
      </Auxiliary>
    );
  }
}

export default Layout;
